
import { defineComponent, onMounted } from "vue";
import ForgotPasswordButton from "../../../components/forgot-password-button.vue";
import { useLoginForm } from "../../../composition";
import { clearLocalStorageAuthItems } from "@/types/auth-local-storage/auth-local-storage.functions";
import emailAndPasswordInputs from "@/components/email-and-password-inputs.vue";
import { router, Routes } from "@/router";
import BaseButton from "@/ui-library/base-button/base-button.vue";
import AuthenticationPagesLogo from "@/pages/authentication/components/authentication-pages-logo.vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import BaseLoader from "@/ui-library/base-loader/base-loader.vue";

export default defineComponent({
  components: {
    emailAndPasswordInputs,
    ForgotPasswordButton,
    BaseButton,
    AuthenticationPagesLogo,
    BaseTypography,
    BaseLoader,
  },
  setup() {
    const { email, password, signIntoApp, isLoading } = useLoginForm();
    onMounted(() => {
      clearLocalStorageAuthItems();
    });
    return {
      isLoading,
      pageTitle: "Sign in",
      loginFormTitle: "Ava Connect Patient Portal",
      email,
      password,
      signIntoApp,
      goToSignUp: () => router.goTo(Routes.signUp),
    };
  },
});
